module.exports = __webpack_public_path__ + "img/psaltire-slavo-romana-1577-epilog-big.130733ac.png";